<template>
  <div class="ag-loader" :style="computedStyle" />
</template>

<script>
export default {
  props: {
    width: {
      type: [String, Number],
      default: '100%',
    },

    height: {
      type: [String, Number],
      default: 20,
    },

    radius: {
      type: [String, Number],
      default: 4,
    },
  },

  computed: {
    computedWidth() {
      return typeof this.width === 'number' ? `${this.width}px` : this.width;
    },

    computedHeight() {
      return typeof this.height === 'number' ? `${this.height}px` : this.height;
    },

    computedRadius() {
      return typeof this.radius === 'number' ? `${this.radius}px` : this.radius;
    },

    computedStyle() {
      return `
          width: ${this.computedWidth};
          height: ${this.computedHeight};
          border-radius: ${this.computedRadius};
        `;
    },
  },
};
</script>

<style lang="scss" scoped>
.ag-loader {
  display: block;
  background:
    linear-gradient(
      to right,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.5) 50%,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0)
    ),
    #ece7f5;
  background-repeat: repeat-y;
  background-size: 100vw 100px;
  animation: shine 3s ease infinite;
}

@keyframes shine {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}
</style>
